import {useEffect, useState} from 'react';

type ScreenSize = 'extraSmall' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';

const breakpoints: Record<Exclude<ScreenSize, 'extraSmall'>, number> = {
  '2xl': 1536,
  xl: 1280,
  lg: 1024,
  md: 800,
  sm: 640,
};

const getScreenSize = (width: number): ScreenSize => {
  if (width >= breakpoints['2xl']) return '2xl';
  if (width >= breakpoints.xl) return 'xl';
  if (width >= breakpoints.lg) return 'lg';
  if (width >= breakpoints.md) return 'md';
  if (width >= breakpoints.sm) return 'sm';
  return 'extraSmall';
};

const useScreenSize = (): ScreenSize => {
  const [screenSize, setScreenSize] = useState<ScreenSize>(() =>
    getScreenSize(window.innerWidth),
  );

  useEffect(() => {
    const handleResize = () => {
      const newSize = getScreenSize(window.innerWidth);

      setScreenSize(currentSize =>
        newSize !== currentSize ? newSize : currentSize,
      );
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return screenSize;
};

export default useScreenSize;
